import { ListItemText, TableRowProps } from '@mui/material'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import * as locales from '@mui/material/locale'
import styled from '@mui/material/styles/styled'
import React from 'react'

interface MyStyledProps {
  myProp: any
}

const myStyled = styled('div', {
  shouldForwardProp: (prop) => prop !== 'myProp'
})<MyStyledProps>(({ theme, myProp }) => {
  console.log(myProp)
  return {

  }
})

export type SupportedLocales = keyof typeof locales

export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  margin: 0
}))

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: '8px 16px',
  boxSizing: 'border-box',
}));

export interface StyledTableRowProps extends TableRowProps {
  odd?: boolean | undefined
}

export const StyledTableRow = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== 'odd', // Não envia 'odd' para o DOM
})<StyledTableRowProps>(({ theme, odd }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: odd ? theme.palette.action.hover : 'initial',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}))

// EXPORTED METHOD...
export type TableComponentSetCurrPageProps = ((args: {
  page: number
}) => void) | null
// ...EXPORTED METHOD